import useCalendar from '@rebuild/hooks/calendar';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import * as QRCode from 'easyqrcodejs';
import { useCommonData } from '@/hooks';
import { ref } from 'vue';
import dayjs from 'dayjs';
import i18n, { EN } from '@/locales';

export function useTopFive(currentData) {   
    const { downloadIcs } = useCalendar();
    const { viewModule } = useModuleNavigation();
    const { getColumnData } = useCommonData();

    function handleCalendar(item) {
        const { title, date, descUrl } = item || {};

        downloadIcs({
            title,
            startTime: date,
            description: descUrl
        });
    }

    const startTime = date => {
        return new Date().getTime() - date;
    };
    
    const showCountDown = ref(true);
    const handleEnd = item => {
        showCountDown.value = false;
    };
    
    const viewActivity = item => {
        viewModule('investment_activity', item);
    };

    const swiperOptionTop = ref({
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        }
    });

    const qrLink = ref([]);
    const qrCodeRefs = ref([]);

    const showQrCode = () => {
        currentData.forEach((item, index) => {
            if (qrCodeRefs.value[index]) {
                // 清空之前的二维码
                qrCodeRefs.value[index].innerHTML = '';
    
                new QRCode(qrCodeRefs.value[index], {
                    text: qrLink.value[index],
                    width: 190,
                    height: 190,
                    colorDark: '#333333', //二维码颜色
                    colorLight: '#ffffff', //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
                    logo: getColumnData.value.logo,
                    logoWidth: 200 / 5,
                    logoHeight: 200 / 5,
                    quietZone: 0,
                    crossOrigin: 'anonymous'
                });
            }
        });
    };

    const formatConferenceTime = time => {
        let formatStr = i18n.locale === EN ? 'YYYY.MM.DD' : 'YYYY年MM月DD日';
        const yearMonthDay = dayjs(time).format(formatStr);
        const hourMinute = dayjs(time).format(' HH:mm:ss');
        return `${yearMonthDay}${hourMinute}(GMT+8)`;
    };



    return {
        handleCalendar,
        startTime,
        showCountDown,
        handleEnd,
        viewActivity,
        swiperOptionTop,
        qrLink,
        qrCodeRefs,
        showQrCode,
        formatConferenceTime
    }
}